import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPermissionsForRoute } from '../utils/adminNavConfig';
import { canAccessAny, getUserPermissionsFromAuth } from '../utils/userPermissions';
import { normalizeRoleName, getRoleName } from '../utils/auth';

/**
 * Guards a single page by permission list or route path.
 */
const PermissionGate = ({ permissions, path, children }) => {
  const auth = useSelector((state) => state.auth);
  const roleName = normalizeRoleName(getRoleName(auth?.role));
  const isSuperAdmin = roleName === 'super_admin';

  if (isSuperAdmin && path === '/super-admin-roles') {
    return children;
  }

  const userPermissions = getUserPermissionsFromAuth(auth);
  const required =
    permissions?.length > 0 ? permissions : getPermissionsForRoute(path);

  if (!required?.length) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (canAccessAny(userPermissions, required)) {
    return children;
  }

  return <Navigate to="/unauthorized" replace />;
};

PermissionGate.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  path: PropTypes.string,
  children: PropTypes.node,
};

export default PermissionGate;
